var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPincode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.17 3.90286L13.1 2.83286L7.55 8.38286V9.46286H8.63L14.17 3.90286ZM12 1.73286L13.29 0.442861C13.4286 0.302571 13.5936 0.191187 13.7756 0.115166C13.9576 0.0391451 14.1528 0 14.35 0C14.5472 0 14.7424 0.0391451 14.9244 0.115166C15.1064 0.191187 15.2714 0.302571 15.41 0.442861L16.56 1.59286C17.15 2.18286 17.15 3.13286 16.56 3.71286L15.88 4.39286L15.86 4.41286L15.28 4.99286L9.28 10.9929H6V7.73286L12 1.73286ZM9.72 1.18286L9.17 1.73286L7.9 3.00286C4.6 3.05286 2 5.60286 2 9.20286C2 11.5429 3.95 14.6429 8 18.3429C12.05 14.6429 14 11.5529 14 9.20286V9.10286L15.8 7.30286C15.93 7.90286 16 8.54286 16 9.20286C16 12.5229 13.33 16.4529 8 21.0029C2.67 16.4529 0 12.5229 0 9.20286C0 4.22286 3.8 1.00286 8 1.00286C8.58 1.00286 9.16 1.06286 9.72 1.18286Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPincode);
export default __webpack_public_path__ + "static/media/pincode.a7b9ec19247ac4e43a60b9b2365664d3.svg";
export { ForwardRef as ReactComponent };